import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { MessageContext } from "../../../../common/message";
import { GET } from "../../../../utils/fetchUtil";
import ElectionResultsDesktop from "./ElectionResultsDesktop";

const GetElectionResults = () => {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [results, setResults] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location?.state) {
      GET(
        "/vote?electionId=" + location.state.id,
        (response) => {
          setResults(response);
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    }
  }, [location?.state]);

  return (
    <ElectionResultsDesktop
      results={results}
      typeName={location.state.typeName}
      generatedId={location.state.generatedId}
    />
  );
};

export default GetElectionResults;
